export const validate = (values) => {
  const errors = {};
  if (!values.permission) {
    errors.permission = { _error: 'Nama harus diisi' };
  }
  if (!values.path) {
    errors.path = { _error: 'Path harus diisi' };
  }
  return errors;
};
